// utils/validateEmail.js
export function validateEmail(value) {
  // Expresión regular para validar un correo electrónico
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Retorna `true` si el valor coincide con el patrón de correo, de lo contrario, `false`
  return emailPattern.test(value);
}
